const formatPhoneMask = phoneNumber => {
  return phoneNumber
    .replace(/(\d{11})(\d)/, '$1')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3');
};

export default formatPhoneMask;
